const list = ['F108','LE95','LP76','LY35','MB17','KQ48','E424','MG80',];
const gifList = []; 
const ajax_url = 'https://tool.m3guo.com/api/web/m3goods/eq-item/';
const img_src = 'https://web-resource.17m3.com/m3guo/202312/game-invite/tips/';
const img_file = '.jpg';

export default{
    list,
    gifList,
    ajax_url,
    img_src,
    img_file,
}


// WEBPACK FOOTER //
// ./src/directives/config/tipsConfig.js